module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "px-5": "",
      "py-3": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.eventsList,
      "label": "Select an event"
    },
    model: {
      value: (_vm.selectedEvent),
      callback: function($$v) {
        _vm.selectedEvent = $$v
      },
      expression: "selectedEvent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "textarea": "",
      "label": "Message",
      "rows": "5"
    },
    model: {
      value: (_vm.notificationMessage),
      callback: function($$v) {
        _vm.notificationMessage = $$v
      },
      expression: "notificationMessage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "textarea": "",
      "label": "Recipients (comma-separated values)",
      "rows": "2"
    },
    model: {
      value: (_vm.notificationRecipients),
      callback: function($$v) {
        _vm.notificationRecipients = $$v
      },
      expression: "notificationRecipients"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is active?"
    },
    model: {
      value: (_vm.notificationIsActive),
      callback: function($$v) {
        _vm.notificationIsActive = $$v
      },
      expression: "notificationIsActive"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveNotification
    }
  }, [_vm._v("Save settings")])], 1)], 1), _vm._v(" "), _c('AppEditWhatsappNotificationsDialog'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.message))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.event.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.recipients_string))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editElement(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('confirmation-dialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1711ed27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/WhatsappNotifications.vue
// module id = 936
// module chunks = 1